export default "__VITE_ASSET__48a30420__"